import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { FamilyLinkType } from '@bciti/types';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserRecord, Link, UpdateFamilyLinkPayload } from '../../user.model';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'src/app/global/services/message/message.abstract.service';
import { UserService } from '../../service/user.abstract.service';

@Component({
    selector: 'app-edit-family-link-dialog',
    templateUrl: './edit-family-link-dialog.component.html',
    styleUrls: ['./edit-family-link-dialog.component.scss'],
})
export class EditFamilyLinkDialogComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    FamilyLinkType = FamilyLinkType;

    familyLinks = Object.values(FamilyLinkType);

    editFamilyMemberLinkTypeForm: any = new FormGroup({
        link: new FormControl(undefined, [Validators.required]),
        targetUserId: new FormControl(undefined, [Validators.required]),
        reference: new FormControl(undefined, [Validators.required]),
    });

    processingSubmit = false;

    constructor(
        private translateService: TranslateService,
        private dialog: MatDialogRef<EditFamilyLinkDialogComponent>,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data: { userRecord: UserRecord; link: Link },
        private messageService: MessageService,
    ) {}

    get linkLabel() {
        return this.translateService.instant(`pages.userFamily.link.${this.data?.link?.link.toLowerCase()}`);
    }

    ngOnInit(): void {
        this.editFamilyMemberLinkTypeForm.patchValue({
            link: this.data?.link?.link,
            reference: this.data.userRecord.id,
            targetUserId: this.data.link.userId._id,
        });
    }

    closeDialog(): void {
        this.dialog.close();
    }

    /**
     * Change the value of the link type (Children, Sibling, etc)
     * @param e The new link
     */
    public handleSelect(e) {
        switch (e.toUpperCase()) {
            case this.FamilyLinkType.CHILD:
                this.editFamilyMemberLinkTypeForm.patchValue({ reference: this.FamilyLinkType.PARENT });
                break;
            case this.FamilyLinkType.PARENT:
                this.editFamilyMemberLinkTypeForm.patchValue({ reference: this.FamilyLinkType.CHILD });
                break;
            case this.FamilyLinkType.OTHER:
                this.editFamilyMemberLinkTypeForm.patchValue({ reference: this.FamilyLinkType.OTHER });
                break;
            case this.FamilyLinkType.SPOUSE:
                this.editFamilyMemberLinkTypeForm.patchValue({ reference: this.FamilyLinkType.SPOUSE });
                break;
        }
    }

    submit(): void {
        this.processingSubmit = true;
        const payload: UpdateFamilyLinkPayload = this.editFamilyMemberLinkTypeForm.value;

        this.userService
            .modifyFamilyLink(this.data.userRecord.id, payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response) => {
                    this.messageService.success(this.translateService.instant('pages.userFamily.edit.messages.success'));
                    this.processingSubmit = false;
                    this.dialog.close(true);
                },
                (error) => {
                    console.log(error);
                    this.messageService.error(error?.error?.messages?.[0], this.translateService.instant('pages.userFamily.edit.messages.error'));
                    this.processingSubmit = false;
                },
            );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
